import React from 'react'
import DarahService from '../Service/darahService'
import FormInput from './formInput'
import FormDelete from './formDelete'
import Konfirmasi from './konfirmasi'
import { config } from '../Config/config'

export default class index extends React.Component {
    DarahModel = {
        _id: "",
        code: "",
        description: "",
        create_by: localStorage.getItem(config.userid),
        create_on: "",
        modified_by: localStorage.getItem(config.userid),
        modified_on: "",
        deleted_by: localStorage.getItem(config.userid),
        deleted_on: "",
        is_delete: false
    }

    constructor() {
        super()
        this.state = {
            List: [],
            Model: this.DarahModel,
            Mode: "",
            ShowModal: false,
            ShowDelete: false,
            ShowKonfirm: false,
            errors: {},
            filter: {
                search: ''
            },
            userName: localStorage.getItem(config.username)
        }
    }

    //untuk manggil semua data yang ada di db
    loadList = async () => {
        const respon = await DarahService.getAll()
        // const respon = await DarahService.getFilter(this.state.filter)
        // console.log(respon)
        if (respon.success) {
            if (respon.result == 0) {
                // this.setState({
                    alert("Data tidak ada di table")
                // })
            } else {
                this.setState({
                    List: respon.result
                })
            }
        }
    }

    loadListCari = async () => {
        // const respon = await DarahService.getAll()
        const respon = await DarahService.getFilter(this.state.filter)
        // console.log(respon)
        if (respon.success) {
            console.log(respon.result)
            if (respon.result == 0) {
                // this.setState({
                    alert("Data tidak ada di table")
                    this.loadList()
                // })
            } else {
                this.setState({
                    List: respon.result
                })
            }
        }
    }


    //pertama kali ditampilkan akan muncul loadlist
    componentDidMount() {
        this.loadList()
    }

    createHandler = () => {
        this.setState({
            Mode: "tambah",
            ShowModal: true,
            Model: this.DarahModel
        })
    }

    konfirmHandler = () => {
        this.setState({
            // Mode: "Tambah",
            ShowKonfirm: true,
            // Model: this.DarahModel
        })
    }


    cancelHandler = () => {
        this.setState({
            Mode: "",
            ShowModal: false,
            ShowDelete: false
        })
    }

    handleValidation = () => {
        let Fields = this.state.Model;
        let errors = {};
        let formIsValid = true;

        //Name
        if (!Fields["code"].trim()) {
            formIsValid = false;
            errors["code"] = "Data Tidak Boleh Kosong";
        }
        else if (typeof Fields["code"] !== "undefined") {
            if (!Fields["code"].match(/^[A,B,O]+$/)) {
                formIsValid = false;
                errors["code1"] = "Data Tidak Sesuai";
            }
        }

        this.setState({ errors: errors });
        return formIsValid;
    }


    //fungsi untuk ngisi chekbox
    changeHandler = name => ({ target: { value } }) => {
        //setState untuk mengupdate
        this.setState({
            Model: {
                ...this.state.Model,
                [name]: value
            }
        })
    }

    //button submit supaya data yang sudah di input dapat di save
    saveHandler = async () => {
        //dicek terlebih dahulu apakah mode bertipe edit atau bukan
        if (this.handleValidation()) {
            if (this.state.Mode == "ubah") {
                this.state.Model.modified_by = localStorage.getItem(config.userid)
                const respon = await DarahService.EditData(this.state.Model)
                if (respon.success) {
                    // alert("Succes Update Data")
                    this.loadList()
                    this.setState({
                        Model: this.DarahModel,
                        ShowModal: false,
                        ShowKonfirm: false
                    })
                }
            } else if (this.state.Mode == "hapus") {
                this.state.Model.modified_by = localStorage.getItem(config.userid)
                this.state.Model.deleted_by = localStorage.getItem(config.userid)
                this.state.Model.is_delete = true
                const respon = await DarahService.EditDDelete(this.state.Model)
                if (respon.success) {
                    // alert("Succes Hapus Data")
                    this.loadList()
                    this.setState({
                        Model: this.DarahModel,
                        ShowDelete: false,
                        ShowKonfirm: false
                    })
                }
            } else {
                const respon = await DarahService.addData(this.state.Model)
                console.log(respon)
                if (respon.success) {
                    // alert("Succes Save Data")
                    this.loadList()
                    this.setState({
                        Model: this.DarahModel,
                        ShowModal: false,
                        ShowKonfirm: false
                    })
                }
            }
        } else {
            // alert("Errors")
        }
    }

    //untuk mengambil data sesuai dengan id nya. penulisan id harus sesuai dengan di db
    editHandler = async (_id) => {
        const respon = await DarahService.getById(_id)
        console.log(respon)

        this.setState({
            //membuat mode menjadi edit
            Mode: "ubah",
            ShowModal: true
        })

        if (respon.success) {
            this.setState({
                Model: respon.result
            })
        }
    }

    //hapus data (ubah is_delete)
    hapusHandler = async (_id) => {
        const respon = await DarahService.getById(_id)

        this.setState({
            //membuat mode menjadi edit
            Mode: "hapus",
            ShowDelete: true
        })

        if (respon.success) {
            this.setState({
                Model: respon.result
            })
        }
    }

    //filter
    filterHandler = field => ({ target: { value } }) => {
        //setState untuk mengupdate
        this.setState({
            filter: {
                ...this.state.filter,
                [field]: value
            }
        })
    }

    render() {
        const { List, Model, ShowModal, errors, Mode, ShowDelete, ShowKonfirm } = this.state
        return (
            <div style={{ background: "white" }}>
                {/* {JSON.stringify(List)} */}
                {/* <table class="table"> */}

                {/* <thead style={{ background: "white" }}> */}

                <div class="row">
                    <div class="col-sm-4 col-3">
                        <h4 class="page-title">Golongan Darah</h4>
                    </div>

                    <div class="col-sm-4 col-3">
                        <div class="card-tools">
                            <div class="input-group input-group-sm" >
                                <input type="text" name="table_search" class="form-control float-right" placeholder="Search" onChange={this.filterHandler("search")} />

                                <div class="input-group-append">
                                    <button type="submit" class="btn btn-primary" onClick={() => this.loadListCari()} ><i class="fa fa-search"></i></button>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="col-sm-4 col-3 text-right m-b-20">
                        <button class="btn btn-primary float-right" onClick={this.createHandler}>Tambah</button>
                    </div>
                </div>
                {/* </thead> */}

                {/* <tbody style={{ background: "white" }}> */}
                <table class="table tbl-primary">
                    <thead>
                        <tr class="text-center bg-primary">
                            <th scope="col">KODE</th>
                            <th scope="col">User</th>
                            <th scope="col">DESKRIPSI</th>
                            <th scope="col">#</th>
                        </tr>
                    </thead>
                    <tbody class="table tbl-white">
                        {
                            //map untuk looping di dalam array
                            List.map(data => {
                                console.log(data)
                                return (
                                    <tr class="text-center">
                                        <td>{data.code}</td>
                                        <td>{data.user}</td>
                                        <td>{data.description}</td>
                                        <td>
                                            <button class="btn btn-primary" onClick={() => this.editHandler(data._id)}>U</button>
                                            <button class="btn btn-danger" onClick={() => this.hapusHandler(data._id)}>H</button>
                                        </td>
                                    </tr>
                                )
                            })
                        }
                    </tbody>
                </table>
                {/* </tbody> */}

                {/* </table> */}

                <FormInput changeHandler={this.changeHandler}
                    saveHandler={this.saveHandler}
                    cancelHandler={this.cancelHandler}
                    showModal={ShowModal}
                    Errors={errors}
                    mode={Mode}
                    Model={Model}
                    konfirmHandler={this.konfirmHandler}
                />
                <FormDelete
                    saveHandler={this.saveHandler}
                    cancelHandler={this.cancelHandler}
                    showDelete={ShowDelete}
                    mode={Mode}
                    Model={Model}
                    konfirmHandler={this.konfirmHandler}
                />
                <Konfirmasi
                    saveHandler={this.saveHandler}
                    ShowKonfirm={ShowKonfirm}
                    mode={Mode}
                />

            </div>
        )
    }
}